import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { LeadService } from 'src/app/private/services/lead.service';
import { UsersService } from 'src/app/private/services/users.service';
import { Router } from '@angular/router';
import { ApplicationService } from 'src/app/private/services/application.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { PopoverModule } from 'primeng/popover';
import { BulkUpdateComponent } from "../../components/leads/bulk-update/bulk-update.component";
import { LeadEmailComponent } from "../../components/leads/lead-email/lead-email.component";
import { RegistrationService } from 'src/app/private/services/registration.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { LeadCallComponent } from "../../components/leads/lead-call/lead-call.component";
import { WhatsappCommunicationComponent } from "../../components/leads/whatsapp-communication/whatsapp-communication.component";
import { AddEnrollmentComponent } from "../../components/enrollment/add-enrollment/add-enrollment.component";
import { BulkDeleteApplicationComponent } from "../../components/application/bulk-delete-application/bulk-delete-application.component";
import { BulkDeleteEnrollmentComponent } from "../../components/enrollment/bulk-delete-enrollment/bulk-delete-enrollment.component";
import { DeleteEnrollmentComponent } from "../../components/enrollment/delete-enrollment/delete-enrollment.component";
import { UploadDocumentsComponent } from "../../components/registration/upload-documents/upload-documents.component";
import { MoveToAdmissionComponent } from "../../components/enrollment/move-to-admission/move-to-admission.component";
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { BatchService } from 'src/app/private/services/batch.service';
import { CreateStudentProfileComponent } from "../../components/enrollment/create-student-profile/create-student-profile.component";
import { PdfFormGeneratorService } from '../../services/pdf-form-generator.service';


@Component({
  selector: 'app-enrollments',
  imports: [ToolBarComponent, SharedModule, PopoverModule, BulkUpdateComponent, LeadEmailComponent, LeadCallComponent, WhatsappCommunicationComponent, AddEnrollmentComponent, BulkDeleteEnrollmentComponent, DeleteEnrollmentComponent, UploadDocumentsComponent, MoveToAdmissionComponent, CreateStudentProfileComponent, ConfirmDialogModule],
  templateUrl: './enrollments.component.html',
  styleUrl: './enrollments.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class EnrollmentsComponent {
  selectedProducts: any[] = [];
  startDate: any = null;
  endDate: any = null;
  rows: number = 25;
  isOpenAddDialog: boolean = false;

  isBulkUpdate: boolean = false;
  isBulkCreateEnteranceExam: boolean = false;
  isBulkSendEmail: boolean = false;
  isBulkDeleteEnrollments: boolean = false;
  isCallLead: boolean = false;
  isEmailLead: boolean = false;
  leadDetails: any = null;
  loading: boolean = false;
  dataSource: any[] = [];
  displayedColumns: any[] = [];
  totalRecords: number = 0;
  editLeadData: any = null;
  isUploadDocument: boolean = false;
  isDeleteEnrollment: boolean = false;
  isMoveToAdmission: boolean = false;
  isBulkAction: boolean = false;
  isUpdateLeadSpace: boolean = false;
  isDeleteLeadSpace: boolean = false;
  isCreateStudentProfile: boolean = false;
  users: any[] = [];
  allCourses: any[] = [];

  filtersOptions: any[] = [];
  exportItems: any[] = [];
  tabItems: any[] = [];
  isWhatsappLead: boolean = false;
  isAdminUser: boolean = false;

  academicYears: any[] = [];
  departments: any[] = []
  batches: any[] = [];
  allLeadFeilds: any[] = [];

  bulkActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Update Enrollments',
          icon: 'pi pi-pencil',
          command: () => {
            this.isBulkUpdate = true;
          }
        },

        // {
        //   label: 'Create Enterance Exam',
        //   icon: 'pi pi-file-import',
        //   command: () => {
        //     this.isBulkCreateEnteranceExam = true;
        //   }
        // },
        {
          label: 'Send Email',
          icon: 'pi pi-envelope',
          command: () => {
            const emailMode = this.localStorage.getDefaultEmailCommunicationMode();
            
            if (emailMode === 'none' || !emailMode) {
              this.confirmationService.confirm({
                message: 'Your communication medium is not connected. Please connect your communication medium to send email.',
                header: 'Communication Medium Not Connected',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Connect Communication',
                rejectLabel: 'Cancel',
                acceptButtonStyleClass: 'p-button-warning',
                accept: () => {
                  this.confirmationService.close();
                  this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
                },
                reject: () => {
                  this.confirmationService.close();
                }
              });
              return;
            }
            
            this.isBulkSendEmail = true;
          }
        },
        {
          label: 'Delete Enrollments',
          icon: 'pi pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isBulkDeleteEnrollments = true;
          }
        }
      ]
    }
  ];

  leadActionItems: any[] = [];


  constructor(
    private localStorage: LocalStorageService,
    private api: LeadService,
    private academicService: AcademicYearService,
    private batchService: BatchService,
    private userApi: UsersService,
    private router: Router,
    private applicationService: ApplicationService,
    private messageService: MessageService,
    private registrationApi: RegistrationService,
    private pdfFormGenerator: PdfFormGeneratorService,
    private confirmationService: ConfirmationService
  ) {
    this.isAdminUser = this.localStorage.isAdminUser();
  }

  openEnrollmentProfile(rowData: any) {
    this.router.navigate([`/main/enrollment/${rowData.enrollment_data?.lead_id}`]);
  }

  ngOnInit() {
    this.setFilterOptions();
    this.setFixedColumn();
    this.getAllUsers();
    this.getLeadsFields();
    this.setExportColumns();
    this.getAllCourses();
    this.getAllAcademicYears();
    this.getAllDepartments();
    this.getAllBatches();

  }



  getAllAcademicYears() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.academicService.getAllAcademicYears(param).subscribe({
      next: (data) => {
        this.academicYears = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllDepartments() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };

    this.userApi.getAllDepartment(param).subscribe({
      next: (data) => {
        this.departments = data || [];
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllBatches() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.batchService.getAllBatches(param).subscribe({
      next: (data) => {
        this.batches = data || [];
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.registrationApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.allCourses = data || [];
        this.allCourses = this.allCourses.map((course: any) => {
          course.course_id = parseInt(course.course_id);
          return course;
        }
        );
      },
      error: (e) => {
        console.error(e);
      },
    });
  }


  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getLeadsFields() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      module_type: 'enrollment'
    };
    this.api.getLeadsFields(param).subscribe({
      next: (data) => {
        this.allLeadFeilds = data?.fields?.sort((a: any, b: any) => a.order - b.order) || [];
        data?.fields?.forEach((element: any) => {

          this.exportItems.push(
            {
              label: element?.label,
              value: element?.field_name,
              checked: false,
              type: 'dynamic_fields'
            }
          );

          if (element.visible_in_table == 'true') {
            this.displayedColumns.push(
              {
                field: element?.field_name,
                header: element?.label,
                type: 'dynamic_fields'
              }
            );
          }
        });

        this.displayedColumns.push(
          {
            field: 'action',
            header: 'Actions',
            type: 'actions'
          }
        );

      },
      error: (e) => {
        console.error(e);
      },
    });
  }


  loadEnrollments(event: any, searchValue?: string, searchAttribute?: string) {
    this.loading = true;

    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;

    const body: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId(),
        "current_stage": "enrollment",
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"lead\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    if (!this.isAdminUser) {
      body.where['user_id'] = this.localStorage.getUserId();
    }

    if (searchValue && searchAttribute) {
      body.filter = {
        ...body.filter,
        "current_stage": "enrollment",
        [searchAttribute]: searchValue
      }
    }

    if (this.startDate && this.endDate) {
      body.startDate = this.startDate;
      body.endDate = this.endDate;
    }

    this.api.getAllLeads(body).subscribe({
      next: (data) => {
        this.dataSource = data.rows
        this.totalRecords = data.count;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  setFilterOptions() {
    this.filtersOptions.push({ header: 'First Name', value: 'first_name', type: 'text' });
    this.filtersOptions.push({ header: 'Last Name', value: 'last_name', type: 'text' });
    this.filtersOptions.push({ header: 'Email', value: 'email', type: 'text' });
    this.filtersOptions.push({ header: 'Phone', value: 'phone', type: 'text' });
    this.filtersOptions.push({ header: 'Source', value: 'source', type: 'text' });
    this.filtersOptions.push({ header: 'Lead Status', value: 'lead_status', type: 'text' });
  }

  handleSearch(event: any) {
    console.log(event);
    this.loadEnrollments({ first: 0, rows: this.rows }, event.value, event.selectedFilterAttribute);
  }

  fnHandleAddd() {
    this.isOpenAddDialog = true;
  }

  handleDateFilter(event: any) {
    // console.log('Date Filter:', event);
    if (event.startDate && event.endDate) {
      this.startDate = event.startDate;
      this.endDate = event.endDate;
      this.loadEnrollments({ first: 0, rows: this.rows }, undefined, undefined);
    } else {
      this.startDate = '';
      this.endDate = '';
      this.loadEnrollments({ first: 0, rows: this.rows });
    }
  }


  handleResetFilters() {
    this.startDate = '';
    this.endDate = '';
    this.loadEnrollments({ first: 0, rows: this.rows });
  }

  setFixedColumn() {

    this.displayedColumns.push({
      field: 'enrollment_id',
      header: 'Enrollment ID',
      type: 'enrollment_id'
    });

    this.displayedColumns.push({
      field: 'contact_name',
      header: 'Contact Name',
      type: 'contact_name'
    });

    this.displayedColumns.push({
      field: 'Communicate',
      header: 'Communicate',
      type: 'communicate'
    });

    this.displayedColumns.push({
      field: 'student_profile',
      header: 'Student Profile',
      type: 'student_profile'
    });

    this.displayedColumns.push({
      field: 'createdAt',
      header: 'Added On',
      type: 'createdAt'
    });

    // this.displayedColumns.push({
    //   field: 'user',
    //   header: 'Sales Owner',
    //   type: 'nested'
    // });

    this.displayedColumns.push({
      field: 'enrollment_status',
      header: 'Status',
      type: 'status'
    });


    this.displayedColumns.push({
      field: 'source',
      header: 'Source',
      type: 'source'
    });

    this.displayedColumns.push({
      field: 'Course',
      header: 'Course',
      type: 'course'
    });

    this.displayedColumns.push({
      field: 'mode',
      header: 'Mode',
      type: 'mode_of_study'
    });

    this.displayedColumns.push({
      field: 'document_status',
      header: 'Document Status',
      type: 'document_status'
    });


    this.displayedColumns.push({
      field: 'payment_status',
      header: 'Payment Status',
      type: 'payment_status'
    });


    this.displayedColumns.push({
      field: 'Assigned To',
      header: 'Assigned To',
      type: 'assigned_to'
    });
  }

  reloadDataTable() {
    this.selectedProducts = [];
    this.loadEnrollments({ first: 0, rows: this.rows });
  }

  handleWhatsappLead(event: any) {
    this.isWhatsappLead = true;
    this.leadDetails = event;
  }


  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' ');
  }


  getStatusColor(status: string): string {
    switch (status) {
      case 'Completed':
        return '#16A34A'; // ✅ Green
      case 'In Progress':
        return '#0EA5E9'; // 🔵 Blue
      case 'Under Review':
        return '#EAB308'; // 🟡 Yellow
      case 'Canceled':
        return '#DC2626'; // 🔴 Red
      case 'Moved':
        return '#8B5CF6'; // 🟣 Purple
      default:
        return '#6B7280'; // ⚪ Gray (Unknown/Default)
    }
  }


  getLeadSourceImg(source: string) {
    if (source == 'tina') {
      source = 'Tina'
    } else if (source == 'whatsapp') {
      source = 'WhatsApp'
    } else if (source == 'manual') {
      source = 'Manual'
    }
    return `/assets/images/${source}.png`;
  }

  handleCallLead(event: any) {
    this.isCallLead = true;
    this.leadDetails = event;
  }

  handleEmailLead(event: any) {
    const emailMode = this.localStorage.getDefaultEmailCommunicationMode();
    
    if (emailMode === 'none' || !emailMode) {
      this.confirmationService.confirm({
        message: 'Your communication medium is not connected. Please connect your communication medium to send email.',
        header: 'Communication Medium Not Connected',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Connect Communication',
        rejectLabel: 'Cancel',
        acceptButtonStyleClass: 'p-button-warning',
        accept: () => {
          this.confirmationService.close();
          this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
        },
        reject: () => {
          this.confirmationService.close();
        }
      });
      return;
    }
    
    this.isEmailLead = true;
    this.leadDetails = event;
  }

  setLeadEditData(data: any) {
    this.editLeadData = data;
    this.updateLeadActionItems();
  }

  updateLeadActionItems() {
    const baseItems: any[] = [
      {
        label: 'Edit Enrollment',
        icon: 'pi pi-fw pi-pencil',
        command: () => {
          this.router.navigate([`/main/enrollment/${this.editLeadData?.lead_id}`]);
        }
      },
      {
        label: 'Move to Admission',
        icon: 'pi pi-fw pi-users',
        command: () => {

          // if admission already created then show message
          if (this.editLeadData?.enrollment_data?.enrollment_status === 'Moved') {
            this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Admission already created for this enrollment' });
            return;
          }

          this.isMoveToAdmission = true;
        }
      }
    ];

    // Only add "Create Student Profile" if is_student_profile is false
    if (!this.editLeadData?.is_student_profile) {
      baseItems.push({
        label: 'Create Student Profile',
        icon: 'pi pi-fw pi-user-plus',
        command: () => {
          this.isCreateStudentProfile = true;
        }
      });
    } else {
      baseItems.push({
        label: 'Create Student Profile',
        icon: 'pi pi-fw pi-user-plus',
        disabled: true,
      });
    }

    baseItems.push(
      {
        label: 'Download Form',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadEnrollmentForm(this.editLeadData);
        }
      },
      {
        label: 'Upload Documents',
        icon: 'pi pi-fw pi-upload',
        command: () => {
          this.isUploadDocument = true;
        }
      },
      {
        label: 'Delete Enrollment',
        icon: 'pi pi-fw pi-trash',
        command: () => {
          this.isDeleteEnrollment = true
        },
        styleClass: 'delete-menu-item'
      } as any
    );

    this.leadActionItems = [
      {
        label: 'Options',
        items: baseItems
      }
    ];
  }

  removeSelectedProducts() {
    this.selectedProducts = [];
  }

  setExportColumns() {
    this.exportItems.push({ label: 'Prefix', value: 'prefix', checked: false });
    this.exportItems.push({ label: 'First Name', value: 'first_name', checked: false });
    this.exportItems.push({ label: 'Last Name', value: 'last_name', checked: false });
    this.exportItems.push({ label: 'Application Number', value: 'application_number', checked: false, type: 'application' });
    this.exportItems.push({ label: 'Contact Phone', value: 'phone', checked: false });
    this.exportItems.push({ label: 'Contact Email', value: 'email', checked: false });
    this.exportItems.push({ label: 'Source', value: 'source', checked: false });
    this.exportItems.push({ label: 'City', value: 'city', checked: false });
    this.exportItems.push({ label: 'State', value: 'state', checked: false });
    this.exportItems.push({ label: 'Country', value: 'country', checked: false });
    this.exportItems.push({ label: 'Date of Birth', value: 'date_of_birth', checked: false });
    this.exportItems.push({ label: 'Age', value: 'age', checked: false });
    this.exportItems.push({ label: 'Gender', value: 'gender', checked: false });
    this.exportItems.push({ label: 'Nationality', value: 'nationality', checked: false });
    this.exportItems.push({ label: 'Address', value: 'address', checked: false });
    this.exportItems.push({ label: 'Postal Code', value: 'postal_code', checked: false });
    this.exportItems.push({ label: 'Alternate Phone', value: 'alternate_phone', checked: false });
    this.exportItems.push({ label: 'Interested Course', value: 'interested_course', checked: false });
    this.exportItems.push({ label: 'Preferred Location', value: 'preferred_location', checked: false });
    this.exportItems.push({ label: 'Remarks', value: 'remarks', checked: false });
    this.exportItems.push({ label: 'Status', value: 'status', checked: false, type: 'application' });
    this.exportItems.push({ label: 'Document Status', value: 'document_status', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Guardian Name', value: 'guardian_name', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Guardian Contact', value: 'guardian_contact', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Previous Education', value: 'previous_education', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Course', value: 'preferred_course', checked: false, type: 'registration' });

  }


  export(selectedFields: any) {

    let param: any = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        current_stage: 'enrollment',
        campus_id: this.localStorage.getCampusId(),
      },
    };

    if (!this.isAdminUser) {
      param.where['user_id'] = this.localStorage.getUserId();
    }

    this.messageService.add({
      severity: 'info', summary: 'Exporting',
      detail: 'Exporting data, please wait...',
      sticky: true
    });

    this.api.getAllLeadList(param).subscribe({
      next: (data: any) => {

        const mappedData = data.map((lead: any) => {
          let row: any = {};

          selectedFields.forEach((field: any) => {
            if (field.type === 'dynamic_fields') {
              // Handle dynamic fields
              row[field.label] = lead.dynamic_fields?.[field.value] || '';
            } else if (field.type === 'registration') {
              if (field.value === 'preferred_course') {
                row[field.label] = lead.registration?.course?.name || '';
              } else {
                console.log("field", field)
                console.log("lead", lead.registration?.[field.value])
                console.log("lead", lead.registration)
                row[field.label] = lead.registration?.[field.value] || '';
              }
            } else if (field.type === 'application') {
              row[field.label] = lead.application_data?.[field.value] || '';
            }
            else {
              row[field.label] = lead[field.value] || '';
            }
          });

          return row;
        });

        // Create worksheet & workbook
        const worksheet = XLSX.utils.json_to_sheet(mappedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');

        // Save the file
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        const date = new Date();
        const fileName = `Leads_data_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getTime()}.xlsx`;

        saveAs(dataBlob, fileName);


        this.messageService.clear();

        this.exportItems.forEach((item) => {
          item.checked = false;
        }
        );

      },
      error: (e) => {

        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error exporting data' });

      },
    });
  }

  downloadEnrollmentForm(studentData?: any) {
    if (!studentData) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No Data',
        detail: 'Please select a student to download the form.'
      });
      return;
    }

    this.messageService.add({
      severity: 'info',
      summary: 'Generating',
      detail: 'Generating enrollment form, please wait...'
    });

    // Define form sections with data mapping
    const sections = this.pdfFormGenerator.createFormSectionsWithData(
      {
        'PERSONAL INFORMATION': [
          { label: 'Prefix', key: 'prefix' },
          { label: 'First Name', key: 'first_name' },
          { label: 'Last Name', key: 'last_name' },
          { label: 'Contact Email', key: 'email' },
          { label: 'Contact Number', key: 'phone' },
          { label: 'Alternate Number', key: 'alternate_phone' },
          { label: 'Date of Birth', key: 'date_of_birth' },
          { label: 'Age', key: 'age' },
          { label: 'Gender', key: 'gender' },
          { label: 'Nationality', key: 'nationality' }
        ],
        'ADDRESS INFORMATION': [
          { label: 'Address', key: 'address' },
          { label: 'City', key: 'city' },
          { label: 'State', key: 'state' },
          { label: 'Country', key: 'country' },
          { label: 'Postal Code', key: 'postal_code' }
        ],
        'ACADEMIC INFORMATION': [
          // { label: 'Query Type', key: 'query_type' },
          { label: 'Interested Course', key: 'enrollment_data.course.name' },
          { label: 'Preferred Location', key: 'preferred_location' },
          { label: 'Previous Education', key: 'previous_education' },
          // { label: 'Academic Year', key: 'enrollment_data.academic_year.year' },
          // { label: 'Department', key: 'enrollment_data.department.name' },
          // { label: 'Batch', key: 'enrollment_data.batch.name' }
        ],
        'GUARDIAN INFORMATION': [
          { label: 'Guardian Name', key: 'enrollment_data.guardian_name' },
          { label: 'Guardian Contact', key: 'enrollment_data.guardian_contact' }
        ],
        'ENROLLMENT INFORMATION': [
          { label: 'Enrollment Number', key: 'enrollment_data.enrollment_id' },
          { label: 'Enrollment Date', key: 'enrollment_data.createdAt' },
          // { label: 'Enrollment Status', key: 'enrollment_data.status' },
          // { label: 'Source', key: 'source' },
          { label: 'Remarks', key: 'remarks' }
        ]
      },
      studentData,
      this.allLeadFeilds
    );

    // Generate PDF using common service
    const studentName = `${studentData.fname || ''}_${studentData.lname || ''}`.trim() || 'Student';
    const date = new Date();
    const fileName = `Enrollment_Form_${studentName}_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}.pdf`;
    
    this.pdfFormGenerator.generatePDFForm({
      formTitle: 'ENROLLMENT FORM',
      fileName: fileName,
      sections: sections,
      showSignature: true,
      watermarkText: 'This is an official enrollment form. Please ensure all information is accurate and complete.',
      data: studentData
    });
  }
}
